import React from 'react';
import { CardDesign } from '../../../../../../../components/CardDesign';
import Address from './Address';
import { ReactComponent as AddressIcon } from '../../../../../../../resource/AddressIcon.svg';
import { getOptionsByDrobdownSelect } from '../../../../../shared/utils/getShutdownsOptions';
import {
  SET_STREET_ID_SHUTDOWN_FILTER,
  SET_HOUSE_ID_SHUTDOWN_FILTER,
  SET_ADDRESS_IDS_SHUTDOWN_FILTER,
} from '../../../model/types';
import { applyShutdownFilter } from '../../../model/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectShutdownsFilter } from '../../../model/selectors';
import useRequestStreets from '../../../../../../../queries/useRequestStreets';
import useRequestHouses from '../../../../../../../queries/useRequestHouses';
import useRequestAddresses from '../../../../../../../queries/useRequestAddresses';
import { getShutdownsOptionsSelectStreet } from '../../../../../shared/utils/getShutdownsOptions';

const AddressFilterCard = () => {
  const { streetId, houseId, addressIds } = useSelector(selectShutdownsFilter);

  const dispatch = useDispatch();

  const { data: streetsOptions = [], isFetching: isStreetsFetching } =
    useRequestStreets({ staleTime: Infinity });

  const { data: housesOptions = [], isFetching: isHousesFetching } =
    useRequestHouses(streetId, {
      enabled: Boolean(streetId),
    });

  const { data: flatsOptions = [], isFetching: isFlatsFetching } =
    useRequestAddresses(houseId, {
      enabled: Boolean(houseId && streetId),
    });

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyShutdownFilter(actionType)(value));
  };

  const streetConfig = {
    data: getShutdownsOptionsSelectStreet(streetsOptions),
    value: streetId,
    onChange: makeChangeHandler(SET_STREET_ID_SHUTDOWN_FILTER),
    isLoading: isStreetsFetching,
  };

  const houseConfig = {
    data: getOptionsByDrobdownSelect(housesOptions),
    value: houseId,
    onChange: makeChangeHandler(SET_HOUSE_ID_SHUTDOWN_FILTER),
    isLoading: isHousesFetching,
  };

  const addressConfig = {
    data: getOptionsByDrobdownSelect(flatsOptions, true),
    value: addressIds,
    onChange: makeChangeHandler(SET_ADDRESS_IDS_SHUTDOWN_FILTER),
    isLoading: isFlatsFetching,
  };

  return (
    <CardDesign style={{ backgroundColor: 'white' }}>
      <CardDesign.Header
        heading="Адрес"
        icon={<AddressIcon />}
      />

      <CardDesign.Body>
        <Address
          streetConfig={streetConfig}
          houseConfig={houseConfig}
          addressConfig={addressConfig}
        />
      </CardDesign.Body>
    </CardDesign>
  );
};

export default AddressFilterCard;
